import * as angular from "angular";
import * as _ from "lodash";
import {Expense} from "../models/expenses.model";
import {Attachment} from "../../attachments/models/attachment.model";
import {AttachmentsService} from "../../attachments/services/attachments-service.service";
import {CommonsAlertsService} from "../../commons/services/commons-alerts.service";
import {CommonsDialogService} from "../../commons/services/commons-dialog.service";

export class ExpensesDialogService {


  constructor(private $mdDialog, private splitService, private commonsDialogService: CommonsDialogService,
              private commonsConstants, private commonsAlertsService: CommonsAlertsService, private attachmentsService: AttachmentsService) {

  }

  createExpense(event, serviceId?) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/create-expense-dialog.html').default,
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: function ($scope, $log) {

        $scope.header = 'Create Expense';
        $scope.expense = {serviceId: serviceId};
        $scope.expense.currencyCode = self.splitService.getCurrencyCode();

        $scope.cancel = self.$mdDialog.cancel;

        $scope.onServiceSelect = (serviceId) => {
          const expenseCopy = angular.copy($scope.expense);
          expenseCopy.serviceId = serviceId;
          $scope.expense = expenseCopy;
        }

        $scope.onChange = (expense) => {
          $scope.expense = angular.copy(expense);
        }

        $scope.afterUpload = (uploadedResult, fileType) => {
          const imageUrl = _.get(uploadedResult, 'url');
          if (imageUrl) {
            const attachment: Attachment = {
              url: imageUrl,
              name: _.get(uploadedResult, 'name'),
              mimeType: fileType,
            };
            if (!$scope.expense.attachments) {
              $scope.expense.attachments = []
            }
            const expenseCopy = angular.copy($scope.expense);
            expenseCopy.attachments.push(attachment);
            $scope.expense = expenseCopy;
          }
        }


        $scope.onUploadImage = (files, invalidFiles) => {
          if (_.get(invalidFiles, 'length') > 0) {
            self.commonsAlertsService.fileFormatError();
          }
          self.attachmentsService.addAttachment(files[0])
            .then((result) => {
              $scope.afterUpload(result, files[0].type);
            })
            .catch(() => {
              $log.info('Closed File Upload')
            })

        }


        $scope.onSubmit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              self.$mdDialog.hide($scope.expense);
            }
          }
        }
      }
    })
  }

  editExpense(expense: Expense, event) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/create-expense-dialog.html').default,
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: function ($scope, $log) {

        $scope.isEditExpense = true;
        $scope.header = 'Edit Expense';
        $scope.loading = false;


        const expenseCopy: Expense = angular.copy(expense)
        const attachmentsNames = _.map(expenseCopy.attachments, (at) => {
          return at.name;
        })

        $scope.loading = true;
        if(attachmentsNames.length){
          self.attachmentsService.getAttachmentsUrls(attachmentsNames)
            .then((attachments: any[]) => {
              const mapByName = _.mapKeys(attachments, (value, key) => {
                return value.name;
              });
              expenseCopy.attachments = _.values(mapByName);
              $scope.expense = expenseCopy;
            })
            .finally(() => {
              $scope.loading = false;
            })
        }

        $scope.cancel = self.$mdDialog.cancel;

        $scope.onChange = (expense) => {
          $scope.expense = angular.copy(expense);
        }

        $scope.afterUpload = (uploadedResult, fileType) => {
          const imageUrl = _.get(uploadedResult, 'url');

          if (imageUrl) {
            const attachment: Attachment = {
              url: imageUrl,
              name: _.get(uploadedResult, 'name'),
              mimeType: fileType,
            };
            if (!$scope.expense.attachments) {
              $scope.expense.attachments = []
            }
            const expenseCopy = angular.copy($scope.expense);
            expenseCopy.attachments.push(attachment);
            $scope.expense = expenseCopy;
          }
        }

        $scope.onUploadImage = (files, invalidFiles) => {
          if (_.get(invalidFiles, 'length') > 0) {
            self.commonsAlertsService.fileFormatError();
          }
          self.attachmentsService.addAttachment(files[0])
            .then((result) => {
              $scope.afterUpload(result, files[0].type);
            })
            .catch(() => {
              $log.info('Closed File Upload')
            })
        }

        $scope.onSubmit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              self.$mdDialog.hide($scope.expense);
            }
          }
        }

      }
    })
  }

}

angular
  .module('bringoz.admin.expenses')
  .service('expensesDialogService', ExpensesDialogService);
